import { faTrashAlt } from '@fortawesome/free-regular-svg-icons';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { Table, Button } from 'react-bootstrap';
import toast from 'react-hot-toast';
import swal from 'sweetalert';
import { useAppContext } from '../../../context';
import TableLoader from '../../Shared/TableOrder/TableOrder';
import AddService from '../AddService/AddService';

const ManageServices = () => {
    const { state: { email } } = useAppContext();

    const [services, setServices] = useState([]);
    const [edit, setEdit] = useState(null);

    useEffect(() => {
        const data = [
            {
                _id: 1,
                name: "Custom CRM Development",
                price: "15000",
                description: "Customized CRM solutions for customers, vendors, orders and business management."
            },
            {
                _id: 2,
                name: "Website Development",
                price: "10000",
                description: "Modern responsive websites for startups, businesses and service providers."
            },
            {
                _id: 3,
                name: "Software Development",
                price: "25000",
                description: "Custom software solutions according to business workflow and requirements."
            }
        ];

        setServices(data);
    }, []);

    const checkPermission = (id, action) => {
        const getMainServices = services.slice(0, 6);
        const getService = getMainServices.find(({ _id }) => id === _id);

        if (getService && email === "test@admin.com") {
            swal(
                "Permission restriction!",
                "As a test admin, you can't edit or delete the main six services. You can only edit or delete your added services",
                "info"
            );
        } else {
            if (action === 'edit') {
                setEdit(id);
            } else {
                handleDelete(id);
            }
        }
    };

    const handleDelete = (id) => {
        swal({
            title: "Are you sure?",
            text: "Are you sure! you want to delete this service?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(wantDelete => {
            if (wantDelete) {
                const updatedServices = services.filter(service => service._id !== id);
                setServices(updatedServices);
                toast.success('Service has been deleted successfully!');
            }
        });
    };

    return (
        <>
            {
                edit ?
                    <AddService
                        edit={edit}
                        setEdit={setEdit}
                        services={services}
                    />
                    :
                    services.length === 0 ?
                        <TableLoader />
                        :
                        <div className="orderList">
                            <Table hover width="100%">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Description</th>
                                        <th>Price</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {
                                        services.map(({ _id, name, price, description }) => {
                                            return (
                                                <tr key={_id}>
                                                    <td>{name}</td>
                                                    <td>{description ? description : "Nothing"}</td>
                                                    <td>₹{price}</td>
                                                    <td>
                                                        <Button
                                                            variant="outline-success"
                                                            onClick={() => checkPermission(_id, 'edit')}
                                                        >
                                                            <FontAwesomeIcon icon={faEdit} /> Edit
                                                        </Button>

                                                        <Button
                                                            className="ml-2"
                                                            variant="outline-danger"
                                                            onClick={() => checkPermission(_id, 'delete')}
                                                        >
                                                            <FontAwesomeIcon icon={faTrashAlt} /> Delete
                                                        </Button>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    }
                                </tbody>
                            </Table>
                        </div>
            }
        </>
    );
};

export default ManageServices;